/**
 * Container used for pages that have a viewing feature (relapse, status, scores...)
 * Manages the viewing state by saving and loading the _id of the document being viewed to redux store
 */

import { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { forEach } from 'ramda';
import { connect } from 'react-redux';

import { actions } from 'store/viewstate';

class ViewStateContainer extends Component {
  constructor(props) {
    super(props);
    this.handleView = (name, id) => !props.editingDocument && this.props.setViewId(name, id);
  }

  static propTypes = {
    editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    children: PropTypes.node,
    setViewId: PropTypes.func.isRequired,
    clearViewId: PropTypes.func.isRequired,
    names: PropTypes.array.isRequired,
    viewId: PropTypes.object,
  };

  componentWillUnmount() {
    forEach(name => this.props.clearViewId(name), this.props.names);
  }

  render() {
    const { children, viewId, ...other } = this.props;
    return cloneElement(children, { ...other, onView: this.handleView, viewId });
  }
}

const mapStateToProps = (state, ownProps) => {
  if (!state || !state.viewstate || !Array.isArray(ownProps.names)) return { viewId: null };

  const viewEntry = Object.entries(state.viewstate).find(([name, id]) => ownProps.names.includes(name) && !!id);
  if (!viewEntry) return { viewId: null };

  return { viewId: { name: viewEntry[0], id: viewEntry[1] } };
};

export default connect(mapStateToProps, actions)(ViewStateContainer);
